<template>
  <layout-home>
    <transition appear name="fade-in">
      <Navigation />
    </transition>
    <div class="main__content">
      <div class="main__content-wrap">
        <!-- <Logo game="bg3" /> -->
        <!-- <button-sales></button-sales> -->
        <slide-in :delay="1100">
          <Notice
            v-if="areModsInstalled && noticeMods"
            :text="noticeMods"
            warning
          />
        </slide-in>
        <slide-in :delay="1200">
          <Notice v-if="system === 'windows'" :text="noticeWindows" />
          <Notice v-if="system === 'macos' && noticeMac" :text="noticeMac" />
        </slide-in>
        <div class="main__buttons">
          <div class="main__buttons-wrap">
            <template v-if="frontendVersion === 'v2'">
              <template v-if="launchableGame === 'bg3'">
                <!-- <slide-in v-if="continueButton" :delay="1500" class="button-wrap">
                  <button-continue @click="continueGame" />
                </slide-in> -->
                <slide-in :delay="1600" class="button-wrap">
                  <button-play @click="runGame" />
                </slide-in>
              </template>
              <template v-else>
                <slide-in :delay="1500" class="button-wrap">
                  <button-get-game :href="getGameLink" />
                </slide-in>
              </template>
            </template>
          </div>
          <slide-in :delay="1650">
            <div v-if="frontendVersion === 'v2' && launchableGame === 'bg3'">
              <div v-if="system === 'windows'">
                <div class="render">
                  <div class="render__options">
                    <a
                      href="#"
                      class="render__option"
                      id="pad-engine-2"
                      pad-up="go:#pad-play"
                      pad-right="go:#pad-engine-1"
                      pad-left="go:#pad-engine-1"
                      pad-a="click"
                      @click.prevent="renderingEngine = 'dx11'"
                    >
                      <div
                        class="radio"
                        :class="{ active: renderingEngine === 'dx11' }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                        >
                          <polyline
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-width="2"
                            points=".502 5.076 4.778 9.353 11.758 .353"
                            transform="translate(1 1)"
                          />
                        </svg>
                      </div>
                      <span>DirectX 11</span>
                    </a>

                    <a
                      href="#"
                      class="render__option"
                      id="pad-engine-1"
                      pad-up="go:#pad-play"
                      pad-right="go:#pad-news-1"
                      pad-left="go:#pad-engine-2"
                      pad-a="click"
                      @click.prevent="renderingEngine = 'vulkan'"
                    >
                      <div
                        class="radio"
                        :class="{ active: renderingEngine === 'vulkan' }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                        >
                          <polyline
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-width="2"
                            points=".502 5.076 4.778 9.353 11.758 .353"
                            transform="translate(1 1)"
                          />
                        </svg>
                      </div>
                      <span> Vulkan</span>
                    </a>
                  </div>
                </div>
              </div>

              <div v-if="system === 'macos' && architecture === 'arm64'">
                <div class="render">
                  <div class="render__options">
                    <a
                      href="#"
                      id="pad-engine-1"
                      pad-right="go:#pad-engine-2"
                      pad-up="go:#pad-play"
                      pad-left="run:leaveWebView,left"
                      class="render__option"
                      @click.prevent="renderingEngine = 'rosetta'"
                    >
                      <div
                        class="radio"
                        :class="{ active: renderingEngine === 'rosetta' }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                        >
                          <polyline
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-width="2"
                            points=".502 5.076 4.778 9.353 11.758 .353"
                            transform="translate(1 1)"
                          />
                        </svg>
                      </div>
                      <span>Rosetta - Intel</span>
                    </a>
                    <a
                      href="#"
                      id="pad-engine-2"
                      pad-up="go:#pad-play"
                      pad-left="go:#pad-engine-1"
                      pad-right="go:#pad-news-1"
                      class="render__option"
                      @click.prevent="renderingEngine = 'arm64'"
                    >
                      <div
                        class="radio"
                        :class="{ active: renderingEngine === 'arm64' }"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                        >
                          <polyline
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-width="2"
                            points=".502 5.076 4.778 9.353 11.758 .353"
                            transform="translate(1 1)"
                          />
                        </svg>
                      </div>
                      <span>ARM64</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </slide-in>
        </div>
      </div>
      <aside>
        <slide-in :delay="1600" direction="left">
          <News :cache-version="cacheVersion" game="bg3" />
        </slide-in>
        <slide-in :delay="1700" direction="left">
          <MerchWidget :cache-version="cacheVersion" />
        </slide-in>
      </aside>
    </div>
  </layout-home>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import ClickOutside from "vue-click-outside";

import layoutHome from "@/layouts/layoutHome.vue";
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import News from "@/components/News.vue";
import MerchWidget from "@/components/MerchWidget.vue";
import Logo from "@/components/ui/Logo.vue";
import Gamepad from "@/utils/gamepadInit";
import Notice from "@/components/ui/Notice.vue";
import SlideIn from "../../components/animations/SlideIn.vue";

export default {
  name: "Bg3Home",
  components: {
    layoutHome,
    Navigation,
    News,
    MerchWidget,
    Logo,
    Notice,
    SlideIn,
  },
  data() {
    return {
      settingsOpened: false,
      noticeWindows: undefined,
      noticeMac: undefined,
      noticeMods: undefined,
    };
  },
  created() {
    this.$store.dispatch("areModsInstalled");
    this.$store.dispatch("getNotice").then((res) => {
      const lang = this.language;
      this.noticeWindows =
        res["LAUNCHER_NOTICE_WINDOWS_" + lang.toUpperCase()].value;
      this.noticeMac = res["LAUNCHER_NOTICE_MAC_EN"].value;
      this.noticeMods = res["LAUNCHER_NOTICE_MODS_" + lang.toUpperCase()].value;
    });

    document.updateAreModsInstalled = this.updateAreModsInstalled;

    console.log(
      "IVOKE updateAreModsInstalled",
      document.updateAreModsInstalled
    );

    document.leaveWebView = this.leaveWebView;
  },
  computed: {
    ...mapState({
      system: (state) => state.system,
      architecture: (state) => state.architecture,
      cacheVersion: (state) => state.cacheVersion,
      launchableGame: (state) => state.launchableGame,
      platform: (state) => state.initPlatform,
      continueButton: (state) => state.continueButton,
      frontendVersion: (state) => state.frontendVersion,
      areModsInstalled: (state) => state.areModsInstalled,
      language: (state) => state.language,
    }),
    macosRenderingMsg() {
      return `<p>Rosetta-based intel application has full ${this.platform} integration. ARM64 application offers better performance, but currently lacks full ${this.platform} platform support.</p>`;
    },
    getGameLink() {
      if (this.platform === "steam") {
        return "https://store.steampowered.com/app/1086940/Baldurs_Gate_3/";
      }

      if (this.platform === "galaxy") {
        return "https://www.gog.com/game/baldurs_gate_iii";
      }

      return "https://baldursgate3.game/";
    },
    renderingEngine: {
      get() {
        return this.$store.state.renderingEngine;
      },
      set(value) {
        this.$store.dispatch("setRenderingEngine", value);
      },
    },
  },
  methods: {
    leaveWebView() {
      document.pad.leaveWebView();
    },
    updateAreModsInstalled() {
      this.$store.dispatch("areModsInstalled");
    },
    async runGame() {
      await this.$store.dispatch("runGame", this.renderingEngine);
    },
    async continueGame() {
      await this.$store.dispatch("continueGame", this.renderingEngine);
    },

    toggleSettings() {
      if (this.settingsOpened) {
        this.settingsOpened = false;
      } else {
        this.settingsOpened = true;
      }
    },
  },
  mounted() {
    this.$store.dispatch("getVersion");
    if (this.system === "macos" && this.architecture === "arm64") {
      this.$store.dispatch("setRenderingEngine", "rosetta");
    }

    this.$store.dispatch("webpageReady");

    Gamepad();
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
// ===================
//    animation
// ===================
.fade-in-enter {
  ::v-deep .navigation__wrap {
    opacity: 0;
    transform: translateY(-100%);
  }
  // transition-delay: 1000ms;
}

.fade-in-enter-to {
  ::v-deep .navigation__wrap {
    opacity: 1;
    transition: opacity 500ms ease, transform 500ms ease;
    transition-delay: 1200ms;
  }
}

// ===================
//    component
// ===================

.main {
  height: 100vh;
  position: relative;
  padding: 0 5vw;
  display: flex;
  flex-direction: column;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: -1;
  }

  &__content {
    height: 100%;
    display: flex;
    margin-top: 5vh;

    // .play-button {
    //   width: 305px;
    // }

    .btn {
      margin: 0;
      align-self: center;
      flex-shrink: 0;
    }
  }

  &__content-wrap {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 50vw;
    margin-right: 5vw;
    margin-bottom: 13vh;
  }

  &__buttons-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
    gap: 15px;

    .play-button {
      width: 100%;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .button-wrap {
    width: 100%;
  }
}

aside {
  display: flex;
  flex-direction: column;
  margin-bottom: 4vh;

  .animation-container:last-child {
    margin-top: auto;
  }
}

.render {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  position: relative;
  z-index: 10;

  &__options {
    display: flex;
  }

  &__option {
    display: flex;
    align-items: center;
    color: $white;
    padding: 15px 20px;

    & > div,
    & > span {
      pointer-events: none;
    }

    &:hover {
      .radio {
        border-color: #64e58d;
        svg {
          opacity: 1;
        }
      }
    }
  }

  .radio {
    width: 26px;
    height: 26px;
    border-style: solid;
    border-width: 2px;
    border-color: rgb(94, 94, 94);
    border-radius: 50%;
    background-color: rgb(0, 0, 0);
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      opacity: 0;
    }

    &.active {
      border-color: #64e58d;
      background-color: #64e58d;

      svg {
        opacity: 1;
        polyline {
          stroke: $dark-grey;
        }
      }
    }
  }
}

.notice {
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  max-width: 426px;

  &__info {
    display: flex;
    padding-left: 10px;
    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
    }
    a {
      color: $white;
      text-decoration: underline;
    }
  }
}

.rendering {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 60px;

  label {
    margin-right: 20px;
  }
}

aside {
  flex-shrink: 0;
  margin-left: auto;
}
</style>
